import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-cake-build-size',
  templateUrl: './ui-cake-build-size.component.html',
  styleUrls: ['./ui-cake-build-size.component.scss']
})
export class UiCakeBuildSizeComponent {
  @Input() size: any;
  @Input() currency = 'kr';
  @Input() active: boolean;
  @Input() discount: number;

  @Output() onSelect = new EventEmitter();
}
